import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import MenuBottom from './../../components/templates/menubottom.vue'; 
import Settings from './../../components/tools/settings.vue';
let service = new services();

export default {
    name: 'Home',
    data () {
        return {
            user:{},
            loggedIn: false,
            loading: true,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-menu-bottom': MenuBottom,
        'c-settings':Settings,
    },
    computed: {
        
    },
    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.loggedIn = true;
                    self.$router.push('/');
                    // self.user.user_id = value.user_id;
                }
            });
        },
        
    },
  
    created: function(){
        let self = this
        setTimeout(function(){
            self.$router.push('/timeline');
        },1500);
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/script.js